/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeviceTokenRequest } from '../models/DeviceTokenRequest';
import type { ForgotPasswordRequest } from '../models/ForgotPasswordRequest';
import type { LoginRequest } from '../models/LoginRequest';
import type { LoginRes } from '../models/LoginRes';
import type { NewUser } from '../models/NewUser';
import type { PushNotificationRequest } from '../models/PushNotificationRequest';
import type { PushNotificationTestRequest } from '../models/PushNotificationTestRequest';
import type { ResetPasswordRequest } from '../models/ResetPasswordRequest';
import type { UpdateUser } from '../models/UpdateUser';
import type { User } from '../models/User';
import type { UserNotification } from '../models/UserNotification';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class UserService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns any List of supported push notification types.
     * @throws ApiError
     */
    public userControllerGetNotificationTypes(): CancelablePromise<Array<{
        type?: string;
        name?: string;
        description?: string;
        dataExample?: Record<string, any>;
    }>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/notifications/types',
        });
    }
    /**
     * @returns any Push notification send result
     * @throws ApiError
     */
    public userControllerSendLogoutPushNotification(): CancelablePromise<{
        sent?: number;
        failed?: number;
        disabled?: number;
        errors?: Array<Record<string, any>>;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/users/logout/push-notification',
        });
    }
    /**
     * @param requestBody
     * @returns any Push notification send result
     * @throws ApiError
     */
    public userControllerTestPushNotification(
        requestBody?: PushNotificationTestRequest,
    ): CancelablePromise<{
        sent?: number;
        failed?: number;
        disabled?: number;
        errors?: Array<Record<string, any>>;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/users/push-notification',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns boolean
     * @throws ApiError
     */
    public userControllerSendReminderEmail(): CancelablePromise<boolean> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/admin/users/send-reminder-emails',
        });
    }
    /**
     * @param id
     * @returns boolean Delete user account by admin
     * @throws ApiError
     */
    public userControllerAdminDeleteUserAccount(
        id: string,
    ): CancelablePromise<boolean> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/users/{id}/account',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns boolean Retun new Match instance
     * @throws ApiError
     */
    public userControllerPayEntryFee(
        id: string,
    ): CancelablePromise<boolean> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/admin/users/{id}/pay-entry-fee',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns any Push notification send result
     * @throws ApiError
     */
    public userControllerSendPushNotification(
        id: string,
        requestBody?: PushNotificationRequest,
    ): CancelablePromise<{
        sent?: number;
        failed?: number;
        disabled?: number;
        errors?: Array<Record<string, any>>;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/users/{id}/push-notification',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns boolean Retun new Match instance
     * @throws ApiError
     */
    public userControllerSendPaymentInfo(
        id: string,
    ): CancelablePromise<boolean> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/admin/users/{id}/send-payment-info',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param requestBody
     * @returns boolean Request password reset email
     * @throws ApiError
     */
    public userControllerForgotPassword(
        requestBody?: ForgotPasswordRequest,
    ): CancelablePromise<boolean> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/users/forgot-password',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns LoginRes User
     * @throws ApiError
     */
    public userControllerLogin(
        requestBody?: LoginRequest,
    ): CancelablePromise<LoginRes> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/users/login',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns boolean Delete current user account
     * @throws ApiError
     */
    public userControllerDeleteMyAccount(): CancelablePromise<boolean> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/users/my/account',
        });
    }
    /**
     * @returns any Mark all current user notifications as read
     * @throws ApiError
     */
    public userControllerMarkAllMyNotificationsRead(): CancelablePromise<{
        count?: number;
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/users/my/notifications/read',
        });
    }
    /**
     * @param id
     * @returns boolean Mark current user notification as read
     * @throws ApiError
     */
    public userControllerMarkMyNotificationRead(
        id: number,
    ): CancelablePromise<boolean> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/users/my/notifications/{id}/read',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param limit
     * @param skip
     * @returns UserNotification Current user notification history
     * @throws ApiError
     */
    public userControllerMyNotifications(
        limit?: number,
        skip?: number,
    ): CancelablePromise<Array<UserNotification>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/my/notifications',
            query: {
                'limit': limit,
                'skip': skip,
            },
        });
    }
    /**
     * @param prompt
     * @returns any OK
     * @throws ApiError
     */
    public userControllerGenerateAvatar(
        prompt?: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/my/profile/generate-avatar',
            query: {
                'prompt': prompt,
            },
        });
    }
    /**
     * @param requestBody
     * @returns boolean Array of Match model instances
     * @throws ApiError
     */
    public userControllerUpdateMyProfile(
        requestBody?: UpdateUser,
    ): CancelablePromise<boolean> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/users/my/profile/update',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns User Return current user id
     * @throws ApiError
     */
    public userControllerMyProfile(): CancelablePromise<User> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/my/profile',
        });
    }
    /**
     * @returns string Test function
     * @throws ApiError
     */
    public userControllerUserPaymentQrCode(): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/payment-qr-code',
        });
    }
    /**
     * @param requestBody
     * @returns User Array of Match model instances
     * @throws ApiError
     */
    public userControllerRegisterUser(
        requestBody?: NewUser,
    ): CancelablePromise<User> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/users/register',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns boolean Reset password by token
     * @throws ApiError
     */
    public userControllerResetPassword(
        requestBody?: ResetPasswordRequest,
    ): CancelablePromise<boolean> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/users/reset-password',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns boolean Return boolean if request is saved
     * @throws ApiError
     */
    public userControllerAnswerBonusQuestion(
        id: string,
        requestBody?: {
            answer?: number;
        },
    ): CancelablePromise<boolean> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/users/{id}/bonus-question',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns boolean Return boolean if request is saved
     * @throws ApiError
     */
    public userControllerRegisterUserDeviceToken(
        id: string,
        requestBody?: DeviceTokenRequest,
    ): CancelablePromise<boolean> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/users/{id}/register-device-token',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
